// fullscreenTipsModule
import React, { createContext } from 'react';
import styled from 'styled-components';
import { useCacheState } from '@/hooks/useCacheState';
import { useStore } from '@/hooks/useStore';
import { isPreviewMode } from '@/utils/tool';
export const FullScreenCtx = /*#__PURE__*/createContext();

const FullscreenTipsModule = props => {
  const {
    children,
    attrs,
    id,
    Render
  } = props;
  const {
    enable
  } = attrs || {}; // 本地存储是否已经读完过的

  const state = useCacheState(`tooltipFullScreen/${window.location.href}`, !isPreviewMode()); // 预览模式预览开关

  const [show] = useStore(`${id}.show`, false);
  const [visible] = state; // enable,配置是否开启了此模块

  return enable && (show || visible) ? /*#__PURE__*/React.createElement(Cover, null, /*#__PURE__*/React.createElement(FullScreenCtx.Provider, {
    value: state
  }, /*#__PURE__*/React.createElement(Render, {
    components: children
  }))) : null;
};

export default FullscreenTipsModule;
const Cover = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  overflow-y: auto;
  z-index: 9999;
  background-color: #fff;
`;